import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";
import SMSStatusCellContent from "../components/SMSStatusCellContent";

function smsWithPassengersStatus({
	width,
	onResize,
	language,
}: Column.Options) {
	return base(
		ColumnId.SMSWithPassengersStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.WITH_PASSENGERS}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsWithPassengersStatus;
